import React, { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import dayjs from 'dayjs';
import { version, buildDate } from '../../appversion';
import appService from 'services/appService';

const ApplicationVersions = () => {
  const [serverInfo, setServerInfo] = useState(null);

  useEffect(() => {
    appService.getServerVersion().then(data => {
      if (data) setServerInfo(data);
    });
  }, []);

  return (
    <span className="font-size-sm">
      <Tooltip
        title={
          buildDate
            ? `Build: ${dayjs(buildDate).format('DD/MM/YYYY HH:mm')}`
            : 'Build date unavailable'
        }
      >
        <span style={{ cursor: 'default' }}>Jarvisly App v{version}</span>
      </Tooltip>

      {serverInfo?.version ? (
        <Tooltip
          title={
            serverInfo?.buildDate
              ? `Build: ${dayjs(serverInfo.buildDate).format('DD/MM/YYYY HH:mm')}`
              : 'Build date unavailable'
          }
        >
          <span style={{ cursor: 'default' }}>
            {' '}(Server v{serverInfo.version})
          </span>
        </Tooltip>
      ) : null}
    </span>
  );
};

export default ApplicationVersions;
